(() => {
  // ====== CONFIG GLOBALE ======
  const LOOPS = 4;
  const LOOP_DELAY = 3000;        // ms
  const DURATION = 5400;          // numero unico O array per header: [1200,1600,1800,1400]
  const FROM = 0;
  const HEADER_SELECTOR = 'h3.how-to-use__card__header';
  const DEBUG = false;
  const MAX_OBS_MS = 10000;

  // >>> Metti qui gli ID delle sezioni da animare
  const SECTION_IDS = [
    'shopify-section-template--26455176806739__multicolumn_dcPhCT',
    'shopify-section-template--26455177331027__multicolumn_YQnr8p'
  ];
  // =============================

  const ease = t => 1 - Math.pow(1 - t, 3);
  const sleep = ms => new Promise(r => setTimeout(r, ms));
  const log = (...a) => { if (DEBUG) console.log('[kpi-loop]', ...a); };

  // Stato per sezione (evita doppi avvii)
  const started = new Map();

  function splitIntoSpan(el, pre, sign, numCore, percent, post) {
    if (el.dataset.kpiSplitDone === 'true') return el.querySelector('[data-kpi-num]');
    const numSpan = document.createElement('span');
    numSpan.setAttribute('data-kpi-num', '');
    numSpan.style.fontVariantNumeric = 'tabular-nums';
    numSpan.style.fontFeatureSettings = '"tnum" 1, "lnum" 1';
    el.textContent = '';
    el.append(document.createTextNode(pre + sign), numSpan, document.createTextNode(percent + post));
    el.dataset.kpiSplitDone = 'true';
    return numSpan;
  }

  function buildItems(root) {
    const nodes = Array.from(root.querySelectorAll(HEADER_SELECTOR));
    if (DEBUG) log('headers trovati in', root.id, ':', nodes.length);

    return nodes.map((el, idx) => {
      const txt = (el.textContent || '').trim();
      // pre | sign | numCore | % | post
      const m = txt.match(/^(.*?)([+-]?)(\d+(?:[.,]\d+)?)(\s*%)(.*)$/);
      if (!m) return null;
      const [, pre, sign, numCore, percent, post] = m;

      const decSep   = numCore.includes(',') ? ',' : '.';
      const decimals = (numCore.split(/[.,]/)[1] || '').length;
      const absEnd   = parseFloat(numCore.replace(',', '.'));
      const end      = (sign === '-') ? -absEnd : absEnd;
      const dur      = Array.isArray(DURATION) ? Number(DURATION[idx] ?? DURATION[DURATION.length - 1]) : Number(DURATION);

      const numEl = splitIntoSpan(el, pre, sign, numCore, percent, post);

      return {
        host: el,
        numEl,
        decimals, decSep, end, dur,
        setVal(v) {
          if (!this.numEl?.isConnected) return;
          this.numEl.textContent = Number(v).toFixed(this.decimals).replace('.', this.decSep);
        }
      };
    }).filter(Boolean);
  }

  function animateAll(items, from, toValues, durations) {
    return new Promise(resolve => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((it, i) => it.setVal(toValues[i]));
        return resolve();
      }
      const t0 = performance.now();
      const step = now => {
        let done = true;
        for (let i = 0; i < items.length; i++) {
          const it = items[i], dur = durations[i];
          const t = Math.min(1, (now - t0) / dur);
          const v = from + (toValues[i] - from) * ease(t);
          it.setVal(v);
          if (t < 1) done = false;
        }
        if (!done) requestAnimationFrame(step);
        else {
          for (let i = 0; i < items.length; i++) items[i].setVal(toValues[i]);
          resolve();
        }
      };
      requestAnimationFrame(step);
    });
  }

  async function runFor(root) {
    const items = buildItems(root);
    if (!items.length) return;

    const toVals = items.map(it => it.end);
    const durs   = items.map(it => it.dur);

    items.forEach(it => it.setVal(FROM)); // reset iniziale

    for (let k = 0; k < LOOPS; k++) {
      await animateAll(items, FROM, toVals, durs);
      if (k < LOOPS - 1) {
        await sleep(LOOP_DELAY);
        items.forEach(it => it.setVal(FROM)); // reset prima del ciclo successivo
      }
    }
  }

  function tryStartForId(id) {
    if (started.get(id)) return true;
    const root = document.getElementById(id);
    if (!root) return false;
    started.set(id, true);
    runFor(root);
    return true;
  }

  function startWithFallbackForId(id) {
    if (tryStartForId(id)) return;
    const obs = new MutationObserver(() => { if (tryStartForId(id)) { obs.disconnect(); clearTimeout(timer); } });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    const timer = setTimeout(() => obs.disconnect(), MAX_OBS_MS);
  }

  // Avvio per ogni sezione richiesta
  function bootAll() {
    SECTION_IDS.forEach(id => startWithFallbackForId(id));
  }

  // Eventi Shopify: rilancia solo sulla sezione toccata
  document.addEventListener('shopify:section:load',   e => { const id = e?.target?.id; if (SECTION_IDS.includes(id)) startWithFallbackForId(id); });
  document.addEventListener('shopify:section:select', e => { const id = e?.target?.id; if (SECTION_IDS.includes(id)) startWithFallbackForId(id); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  window.addEventListener('load', bootAll);
})();